import { render } from "./staff_panel.vue?vue&type=template&id=56c37220"
import script from "./staff_panel.js?vue&type=script&lang=js"
export * from "./staff_panel.js?vue&type=script&lang=js"

import "./staff_panel.vue?vue&type=style&index=0&id=56c37220&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__